import { AskAIButtonProps } from "@/components/static-dashboard-components/charts-components/ChartTopBar";
import { useSelectedChart } from "@/contexts/ChartsContext";
import { Colors } from "@/enums/Colors";
import { MainDashBoardChart } from "@/enums/MainDashBoardChart";
import DateUtils from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/DateUtils";
import { Box, Typography, styled } from "@mui/material";
import { CollapseChart } from "./CollapseChart";

interface Props {
  data: {
    value: number;
    isInfinite: boolean;
  };
}
export const RunwayRunRateChart = ({ data, disableAskAIButton = false }: Props & AskAIButtonProps) => {
  const { selectedChart, setSelectedChart } = useSelectedChart();

  const renderCollapseContent = () => {
    return (
      <Container>
        <Typography>{firstParagraph}</Typography>
        <Typography>
          {data.value <= 6 && secondParagraph(data.value)} {lastParagraph}
        </Typography>
      </Container>
    );
  };

  const runwayDate = new Date();
  runwayDate.setMonth(runwayDate.getMonth() + data.value);

  const generateDisplayValue = () => {
    if (data.isInfinite) {
      return "Profitable!";
    } else if (data.value) {
      return `${DateUtils.formatDate(runwayDate, "MMM ‘YY")} (${data.value} months)`;
    }

    return "";
  };

  return (
    <CollapseChart
      selected={selectedChart === MainDashBoardChart.RUNWAY_RUN_RATE}
      collapseContent={<></>}
      disableAskAIButton={disableAskAIButton}
      title="Runway Run Rate"
      value={generateDisplayValue()}
      onClickStarIcon={() => {
        setSelectedChart(MainDashBoardChart.RUNWAY_RUN_RATE);
      }}
      disableExpand
    />
  );
};

const Container = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "0.5rem",
  "& > p": {
    fontWeight: 500,
    fontSize: "12px",
    color: Colors.LIGHT_GRAY_8A8E93,
  },
}));

const firstParagraph =
  "Your Runway metrics card displays the last month your current Available Cash Balance will be able to fully cover expenses based on your monthly burn rate.";
const secondParagraph = (months: number) =>
  `Your runway of ${months} months suggests that you may want to start planning for your next fundraise.`;
const lastParagraph =
  "It is typically recommended to start the fundraising process at least six months prior to running out of cash. You will want to prepare reports of your financial history, projections, key metrics, and a business plan.";
